import { render, staticRenderFns } from "./ReportContent.vue?vue&type=template&id=47f74e6a"
import script from "./ReportContent.vue?vue&type=script&lang=js"
export * from "./ReportContent.vue?vue&type=script&lang=js"
import style0 from "./ReportContent.vue?vue&type=style&index=0&id=47f74e6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports